<template>
    <div>
        <v-row >
            <v-col cols="7">
                <span> {{cuenta}} </span>
            </v-col>
            <v-col cols="5">
                <span style="float: right"> {{ fecha | moment("YYYY-MM-DD HH:mm:ss") }} </span>
            </v-col>
            <v-col cols="12">
                <span class=""> {{descripcion}} </span>
            </v-col>
        </v-row> 
    </div>
</template>


<script>

export default {
    name: 'Alarma',
    props:{
        cuenta: String,
        fecha: String,
        descripcion: String
    },
    data: () => ({
    })
}
</script>

<style scoped>

 .row-alarma{
       display: block;
 }

 .row-alarma-mobile{
       display: none;
 }

@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px){
  .row-alarma{
       display: none;
  }

   .row-alarma-mobile{
       display: block;
 }
}

.ellipsis {
    text-overflow: ellipsis;
    /* Required for text-overflow to do anything */
    white-space: nowrap;
    overflow: hidden;
  }

  .arbol-texto{
    display: inline-block;
    max-width: 100%;
}

</style>